<form [formGroup]="optionForm" autocomplete="sdf">
	<mat-form-field appearance="outline">
		<mat-label>{{ placeholder }}</mat-label>
		<!--
		<input
			[required]="control.isRequired"
			[readonly]="readOnly"
			type="text"
			[formControl]="control"
			matInput
			[name]="control.name"
			[matAutocomplete]="autoGroup"
			[errorStateMatcher]="matcher"
		/>
-->

		<button
			mat-button
			*ngIf="control.value"
			matSuffix
			mat-icon-button
			aria-label="Clear"
			(click)="control.setValue(''); control.setValue(null)"
		>
			<mat-icon>close</mat-icon>
		</button>
		<!--
		<mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="displayFn">
			<mat-optgroup *ngFor="let group of displayedOptions | async" [label]="group.name">
				<mat-option
					*ngFor="let activity of group.activities"
					[value]="selectedOptions"
					(onSelectionChange)="onEnter(activity)"
				>
					<mat-checkbox
						[checked]="control.value.includes(activity.id)"
						(change)="toggleSelection(activity)"
						(click)="$event.stopPropagation()"
					>
						{{ activity.name }}
					</mat-checkbox>
				</mat-option>
			</mat-optgroup>
		</mat-autocomplete>
-->

		<mat-select [formControl]="control" multiple>
			<mat-optgroup *ngFor="let group of displayedOptions | async" [label]="group.name">
				<mat-option *ngFor="let activity of group.activities" [value]="activity.id">
					{{ activity.name }}
				</mat-option>
			</mat-optgroup>
		</mat-select>

		<!--
    <mat-select *ngIf="multiple" [formControl]="control" [errorStateMatcher]="matcher" [disabled]="readOnly" multiple>
        <mat-option *ngFor="let option of options" [value]="option.id">{{ option.label }}</mat-option>
    </mat-select>
    <mat-select *ngIf="!multiple" [formControl]="control" [errorStateMatcher]="matcher" [disabled]="readOnly">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let option of options" [value]="option.id">{{ option.label }}</mat-option>
    </mat-select> -->

		<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
		<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
			<mat-error *ngIf="control.hasError(key)">
				{{ control.getErrorMessage(key) }}
			</mat-error>
		</ng-template>
	</mat-form-field>
</form>
